module.exports = __webpack_public_path__ + "assets/f19d12224cb9eb9e603eff6d45e39744.mp3";